import { CommonMessage } from './CommonMessage';
import { MessageType } from './MessageType';

export interface EventErrorPayload {
  i: number;
  error: any;
}

export class EventErrorMessage implements CommonMessage {
  t = MessageType.EVENT_ERROR;
  public d: EventErrorPayload;

  constructor(payload: EventErrorPayload) {
    this.d = payload;
  }
}
